import React, {useState, useEffect} from 'react'
import Navbar from '../components/Navbar'
import axios from 'axios';
import moment from 'moment/moment';
import { Fade } from 'react-awesome-reveal'
import CreateClient from '../components/CreateClient';
import OpenClient from '../components/OpenClient';
import LoadingIcon from '../components/LoadingIcon';

function Customer() {

  const [ data, setData ] = useState([]);
  
  const [ filtered, setFiltered ] = useState([]);
  const [ search, setSearch ] = useState("");
  const [ createCustomer, setCreateCustomer ] = useState(false);
  const [ EDITING_CLIENT_ID, set_EDITING_CLIENT_ID ] = useState(""); 

  const [ loading, setLoading ] = useState(true);

  const fetchData = async (e) => {

    const res = await axios.get("https://backend.azupin.glass/customer");

    setData(res["data"])

    filter(res["data"])
    setLoading(false)

  };

  const filter = (e = data) => {
    const filtrd = e.filter(x => 
      x["title"].toLowerCase().includes(search.toLowerCase())
      ||
      x["phoneNumber"]?.toLowerCase().includes(search.toLowerCase())
      ||
      x["email"]?.toLowerCase().includes(search.toLowerCase())
      ||
      x["billingAddress"]?.toLowerCase().includes(search.toLowerCase())
    );

    setFiltered(filtrd);
  }

  useEffect(() => {

    fetchData();

    // eslint-disable-next-line
  }, [])

  useEffect(() => {

    filter();

  }, [search, setSearch])

  return (
    <div className="flex">
      <Navbar />


      {
        createCustomer
        ?
        <CreateClient fetchCustomers={fetchData} setCreateClient={setCreateCustomer} />
        : 
        ""
      }

      {
        EDITING_CLIENT_ID
        ?
        <OpenClient fetchCustomers={fetchData} EDITING_CLIENT_ID={EDITING_CLIENT_ID} set_EDITING_CLIENT_ID={set_EDITING_CLIENT_ID} />
        :
        ""
      }

      <div className="overflow-y-scroll h-screen w-full">
        {
          loading
          ?
          <LoadingIcon />
          :
          <div className={`mx-auto mt-10`}>
            <div className="flex justify-between items-center px-10">
              <h3 className="font-bold text-lg">
                Customers!
              </h3>
              <button onClick={() => setCreateCustomer(true)} className="px-4 py-2 font-bold bg-blue-400 rounded shadow text-white hover:bg-blue-600 duration-300">Create</button>
            </div>
            <div className="flex flex-row justify-start items-start">
              <div className="flex flex-col w-full">
                <div className="overflow-x-auto">
                  <div className="py-2 inline-block min-w-full">
                    <div className="overflow-hidden">
                      <table className="min-w-full">
                        <thead className="bg-white border-b">
                          <tr>
                            <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                              #
                            </th>
                            <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-2 text-left">
                              <input onChange={(e) => setSearch(e.target.value)} placeholder="Search..." className="w-full mb-2 px-2 py-1 border outline-none" />
                            </th>
                            <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                              Address
                            </th>
                            <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                              Credit / Due
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            filtered.map((x, index) => (
                              <tr onClick={() => set_EDITING_CLIENT_ID(x["_id"])} key={x["_id"]} className={`hover:bg-blue-200 cursor-pointer duration-300 border-b ${!Boolean(index % 2) ? "bg-gray-100" : "bg-white"}`}>
                                <td className="px-6 w-28 py-2 whitespace-nowrap text-xs font-medium text-gray-900">
                                  {index + 1}
                                </td>
                                <td className="text-sm text-gray-900 flex flex-col px-6 py-4 whitespace-nowrap">
                                  <p className="text-xs font-light">{x["_id"].slice(-6).toUpperCase()}</p>
                                  <h3 className="font-bold">
                                    {x["title"]}
                                  </h3>
                                  <p className="text-xs truncate w-96">
                                    {x["description"]}
                                  </p>
                                </td>
                                <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap">
                                  <p>
                                    {x["billingAddress"]}
                                  </p>
                                </td>
                                <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap">
                                  <p>
                                    {x["due"] ? "$" + x["due"] : "$0"}
                                  </p>
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        }

      </div>
    </div>
  )
}

export default Customer